import React from 'react';
import {connect} from 'react-redux'
import {openPopup} from 'startlibs'
import {withPopupToggles} from 'startlibs/lib/hocs';

@withPopupToggles("labelEdit","contextMenu")
@connect(undefined,(dispatch)=> ({openPopup:  (id, value) => dispatch(openPopup(id, {value}))}))
export class EditableLabel extends React.Component {

  state = {tempLabel:undefined};
  input = null;
  openedAutomatically = false

  constructor(props) {
    super(props)
    if (this.props.isContextMenuOpen) {
      this.openedAutomatically = true
    }
  }

  tryCloseTempLabel = (e) => {
    if (e.key==='Escape' || e.key === 'Enter' || e.key === 'Tab') {
      this.props.labelEdit.close();
      if (e.key === 'Enter') {
        this.handleChange(this.state.tempLabel)
      }
      this.setState({tempLabel:undefined});
    }
  };

  componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      this.props.labelEdit.close();
      this.props.contextMenu.close();
      return;
    }
    if (this.props.labelEdit.isOpen && !newProps.labelEdit.isOpen) {
      if (this.props.contextMenu.isOpen && !this.openedAutomatically) {
        this.props.labelEdit.toggle();
      } else {
        this.handleChange(this.state.tempLabel);
        this.setState({tempLabel:undefined});
      }
      this.openedAutomatically = false
    }
  }

  handleChange = (tempLabel) => this.props.handleChange(
    tempLabel===undefined?
      this.props.value :
      tempLabel === "" ?
        'Field label' :
        this.state.tempLabel
  )

  selectAll = (e) => {
    e.target.select();
  };

  handleTempLabelChange = (e) => this.setState({tempLabel: e.target.value});

  preventDefault = (e) => {
    e.stopPropagation()
    e.preventDefault();
  }

  toggleMenu = (e) => {
    this.preventDefault(e)
    this.props.openPopup(this.props.popupTogglesId,{labelEdit:this.props.labelEdit.isOpen,contextMenu: !this.props.contextMenu.isOpen})
  }

  render() {
    const {value, labelEdit, labelList, contextMenu} = this.props;
    const {tempLabel} = this.state;
    return <div data-drag={false} className="field-name editable-label" onClick={contextMenu.toggle}>
      {!labelEdit.isOpen && <div>
        <span className="field-label">{value}</span>
      </div>
      }
      {
        labelEdit.isOpen &&
        <input className="editable-label-input" autoFocus={true} onFocus={this.selectAll} onChange={this.handleTempLabelChange}
               onClick={this.preventDefault}
               onKeyDown={this.tryCloseTempLabel} type="text" ref={el=>this.input=el}
               value={tempLabel!==undefined ? tempLabel : value}/>
      }
      {
        labelEdit.isOpen &&
        <span className="context-menu-opener icon icon-arrow-down" onClick={this.toggleMenu}/>
      }
      {contextMenu.isOpen &&
      <ul className="context-menu">
        {labelList()}
        {!labelEdit.isOpen && <li className="separator"/>}
        {!labelEdit.isOpen && <li onClick={labelEdit.toggle}><a><span className="icon icon-edit-box"/>Custom</a></li>}
      </ul>}
    </div>
  }
}




// WEBPACK FOOTER //
// ./~/report-components/src/components/editableLabel.js